<template>
  <!-- OCS唛头 -->
  <div>
    <div class="main" v-for="(datas, index) in printData" :key="index" :datas="index">
      <div class="content">
        <div class="top">
          <img src="../../../src/assets/dayindanicon/ocs-logo.png" alt="" />
        </div>
        <div class="middle">
          <div class="middle-top">
            <div class="barcode">
              <!-- 一维码 -->
              <canvas :id="'express_no' + index" />
            </div>
            <p> {{ datas.express_no }}</p>
            <p style="white-space:nowrap">{{ datas.porder_sn }}-{{ datas.number }}</p>
            <p class="nangong">{{ datas.porder.user.realname }}</p>
            <!-- FBA授权 -->
            <div v-if="datas.porder.is_fba">
              {{ datas.porder.importer.company }}
            </div>
          </div>
          <!-- 原单号 -->
          <div style="height: 150px;">
            <p style="font-size: 40px;" v-if="datas.porder.split_from">原单号:{{ datas.porder.split_from }}</p>
            <p style="font-size: 40px;" v-if="datas.porder.from_porder_sn">原单号:{{ datas.porder.from_porder_sn }}</p>
          </div>
          <p>MADE IN CHINA</p>
          <div class="foot">
            <div>
              <span>担当:</span><span style="margin-left: 15px">{{ datas.porder.y_admin.realname }}</span>
            </div>
            <div>
              <span>配货:</span><span style="margin-left: 15px">{{ datas.porder.p_admin.realname }}</span>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="number">
            <div class="item">
              <p> 重量(KG)：{{ datas.weight }}</p>
              <p> 箱サイズ(CM)：{{ datas.length }}x{{ datas.width }}x{{ datas.height }}</p>
            </div>
            <div class="number_by_express_no ">
              件数：{{ datas.number_by_express_no }}/{{ datas.count_by_express_no }}
            </div>
          </div>
          <div style="padding-bottom:60px">{{ getDate() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {

  data() {
    return {
      getDate
    };
  },
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    )
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },

  mounted() {
    this.printData.forEach((item, index) => {
      this.getJsBarcode("#express_no" + index, item.express_no);
    })

  },
  methods: {

    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 180,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1061px;
  height: 1772px;
  background: #fff;
  padding: 60px;

  color: #000000 !important;


  .content {
    width: 1061px;
    height: 1652px;

    border: 8px solid #000000;

    .top {
      width: 100%;
      height: 320px;
      border-bottom: 8px solid #000000;
      // padding-top: 63px;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      padding: 60px 0;

      img {
        margin: auto;
        display: block;

        width: 500px;
        // margin-top: 63px;
        height: 193px;
      }
    }

    p {
      font-size: 65px;
      text-align: center;
      font-weight: 600;
      color: #000000;
      margin: 20px 0;
    }

    .middle {
      width: 100%;
      height: 856px;
      padding-top: 30px;

      .middle-top {
        margin: auto;
        // margin-top: 80px;
        text-align: center;
        width: 941px;
        // padding: 48px 32px;

        font-size: 50px;
        font-weight: 600;
        color: #000000;


      }

      .mid {

        margin: auto;
        margin-top: 50px;
        text-align: center;

        .nangong {
          margin-top: 40px !important;
          font-size: 48px !important;
          font-weight: 600;
          color: #000000;
        }
      }

      .foot {
        margin-top: 50px;
        padding: 0 60px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 20px;

        div {
          span {
            font-size: 48px;

            font-weight: 400;
            color: #000000;
          }
        }
      }
    }

    .footer {
      width: 100%;
      height: 250px;
      border-top: 8px solid #000000;

      .number {
        margin-top: 45px;
        display: flex;
        position: relative;

        .item {
          margin-left: 60px;

          p {
            font-size: 50px;
            font-weight: 400;
            color: #000000;
            text-align: left;
          }
        }

        .number_by_express_no {
          position: absolute;
          top: 15px;
          right: 0px;
          font-size: 50px;
        }

      }


      div {
        text-align: right;
        font-size: 48px;
        font-weight: 400;
        color: #000000;
        padding-right: 48px;
      }
    }
  }
}
</style>
